import React, { Component } from 'react';
import styled from 'styled-components';
import { Badge, Icon } from 'antd';
import {
  messageError,
  messageSuccess,
  noMessageError,
  noSenderError,
  loadingError,
} from './error';
import setting from './setting';
import doge from './favicon.png';
import send from './send.svg';

const getNickName = () => {
  const { animals } = setting;
  const animal = animals[Math.floor(animals.length * Math.random())];
  return navigator.language.slice(0, 2) === 'zh' ? animal.cname : animal.name;
};

class Messenger extends Component {
  state = {
    messageCount: 0,
    avatar: {
      x: 0,
      y: 0,
    },
    loading: false,
    text: '',
    sender: '',
  };
  componentWillUnmount() {
    window.removeEventListener('mousemove', this.handleMouseMove);
    window.removeEventListener('mouseup', this.onDragEnd);
  }
  onDrag = e => {
    e.preventDefault();
    window.addEventListener('mousemove', this.handleMouseMove);
    window.addEventListener('mouseup', this.onDragEnd);
  };
  onDragEnd = () => {
    window.removeEventListener('mousemove', this.handleMouseMove);
    window.removeEventListener('mouseup', this.onDragEnd);
  };

  onSendButtonClick = () => {
    const { text, sender, messageCount } = this.state;
    if (!sender.length) {
      noSenderError();
    } else if (!text.length) {
      noMessageError();
    } else {
      this.sendMessage();
      this.setState({
        text: '',
        messageCount: messageCount + 1,
        loading: true,
      });
    }
  };
  setNickName = () => {
    this.setState({
      sender: getNickName(),
    });
  };
  handelTextChange = e => {
    this.setState({
      text: e.target.value,
    });
  };
  handelSenderChange = e => {
    this.setState({
      sender: e.target.value,
    });
  };
  handleMouseMove = e => {
    const { x, y, width, height } = this.avatar.getBoundingClientRect();
    e.preventDefault();
    this.setState({
      avatar: {
        x: e.clientX - x - width * 0.5,
        y: e.clientY - y - height * 0.5,
      },
    });
  };
  sendMessage = () => {
    const { text, sender, loading } = this.state;
    if (!loading) {
      fetch('https://sh1zuku.app/sendme/', {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({ message: `From ${sender}:\n${text}` }),
      })
        .then(() => {
          messageSuccess();
          this.setState({
            loading: false,
          });
        })
        .catch(() => {
          messageError();
          this.setState({
            messageCount: this.state.messageCount - 1,
            loading: false,
          });
        });
    } else {
      loadingError();
    }
  };

  render() {
    const { className } = this.props;
    const { loading, avatar, messageCount } = this.state;
    return (
      <div className={className}>
        <div className="messenger-container">
          <div
            className="avatar"
            ref={r => {
              this.avatar = r;
            }}
          >
            <Badge offset={[0, 0]} count={messageCount}>
              <img
                onMouseDown={this.onDrag}
                src={doge}
                alt="avatar"
                style={{ transform: `translate(${avatar.x}px, ${avatar.y}px)` }}
              />
            </Badge>
          </div>
          <div className="bubble">
            <div className="saying" />
            <div className="discription">
              {setting.description.split('\n').map((s, i) => (
                <p style={{ marginBottom: 0 }} key={i}>
                  {s}
                </p>
              ))}
            </div>
          </div>
          <div className="input-group">
            <div>
              <input
                value={this.state.sender}
                placeholder="你/妳是誰？"
                className="ant-input ant-input-lg input"
                onChange={this.handelSenderChange}
              />
              <span className="nick-button">
                <button onClick={this.setNickName}>匿名</button>
              </span>
            </div>
            <div>
              <input
                value={this.state.text}
                placeholder="我想想...傳什麼好呢"
                className="ant-input ant-input-lg input"
                onChange={this.handelTextChange}
              />
              <span className="send-button">
                <button onClick={this.onSendButtonClick}>
                  {loading ? <LoadIcon /> : <SendIcon />}
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const SendIcon = () => (
  <img
    style={{ color: 'white', width: '50%', height: '50%' }}
    src={send}
    alt="go"
  />
);
const LoadIcon = () => (
  <Icon
    style={{ color: 'white', width: '50%', height: '50%' }}
    type="loading"
  />
);

export default styled(Messenger)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  .avatar  {
    position: relative;
    margin: 0 auto;
    background-color: rgb(235, 221, 191);
    border-radius: 50%;
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 2px 2px 2px 0 rgba(0,0,0,0.7);
    &:hover {
      background-color: rgba(230, 213, 186, 1);
    }
  }
  .bubble:hover {
    .discription {
      background-color: ${({ dayTime }) =>
        dayTime === 'night' ? 'rgba(200, 200, 200, .1)' : '#40a9ff'};
    }
    .saying {
      border-bottom-color: ${({ dayTime }) =>
        dayTime === 'night' ? 'rgba(200, 200, 200, .1)' : '#40a9ff'};
    }
  }
  .saying {
    border: 15px transparent solid;
    border-top-width: 15px;
    border-bottom-color: ${({ dayTime }) =>
      dayTime === 'night' ? 'rgba(200, 200, 200, .1)' : '#1890ff'};
    transform-origin:top;
    transform:skewX(20deg);
    position: relative;
    left: 50%;
    width: 0px;
    height:  0px;
    background-color: transparent;
    transition: border-bottom-color 1s;
  }
  .discription {
    position: relative;
    margin: 0 auto 20px;
    background-color: ${({ dayTime }) =>
      dayTime === 'night' ? 'rgba(200, 200, 200, .1)' : '#1890ff'};
    border-radius: 20px;
    padding: 10px;
    color: ${({ dayTime }) => (dayTime === 'night' ? 'white' : 'white')};
    text-align: center;
    transition: background-color 1s;
    /* &:hover {
      background-color: ${({ dayTime }) =>
        dayTime === 'night' ? 'rgba(200, 200, 200, .1)' : '#40a9ff'};
    } */
  }
  .input-group {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 350px;
  }
  .input {
    margin: 0 auto 10px;
    width: 300px;
  }
  .send-button, .nick-button {
    display: inline-flex;
    position:absolute;
    width: 60px;
    height: 40px;
    transform: translateX(-100%);
    background-color: #1890ff;
    border-width: 0;
    border-radius: 4px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    transition: background-color .3s;
    text-align: center;
    &:hover {
      background-color: #40a9ff;
    }
  }
  .nick-button, .send-button {
    button {
      font-size: 14px;
      color: white;
      border: 0;
      width: 100%;
      background: transparent;
    }
  }
  @media (min-width:980px) {
    .messenger-container {
      transform: scale(1.3);
    }
    
  }
  @media (max-width:979px) {
    .input-group {
      width: 320px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Messenger/index.js